// @greenlight-spec: 48-user-passthrough.md#per-user-oauth
// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 28-it-dashboard-ui.md
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ConnectTargetSchema, UserConnectionListSchema, UserConnectionRevokeResultSchema, } from '@greenlight/shared';
import { errorResponses } from './common.js';
const c = initContract();
const ConnectionIdParamsSchema = z.object({ id: z.string().uuid() });
const UserConnectionParamsSchema = z.object({
    id: z.string().uuid(),
    connectionId: z.string().uuid(),
});
/**
 * Per-user OAuth user connections (docs/48 §Per-user OAuth §Lifecycle). The
 * caller's own under `/api/user-connections`; a named user's, for IT, under
 * `/api/users/:id/connections`. No route returns token material.
 */
export const userConnectionsContract = c.router({
    connectTarget: {
        method: 'GET',
        path: '/api/user-connections/target',
        query: z.object({
            integration: z.string().uuid(),
            credential: z.string().min(1).max(63),
            return_to: z.string().optional(),
        }),
        responses: { 200: ConnectTargetSchema, ...errorResponses },
        summary: 'What the Connect page shows for one integration and credential, for the signed-in user.',
    },
    listMine: {
        method: 'GET',
        path: '/api/user-connections',
        responses: { 200: UserConnectionListSchema, ...errorResponses },
        summary: 'List the signed-in user’s own user connections.',
    },
    disconnect: {
        method: 'DELETE',
        path: '/api/user-connections/:id',
        pathParams: ConnectionIdParamsSchema,
        body: z.undefined().optional(),
        responses: { 200: UserConnectionRevokeResultSchema, ...errorResponses },
        summary: 'Disconnect one of the signed-in user’s own user connections.',
    },
    listForUser: {
        method: 'GET',
        path: '/api/users/:id/connections',
        pathParams: ConnectionIdParamsSchema,
        responses: { 200: UserConnectionListSchema, ...errorResponses },
        summary: 'List a user’s user connections (IT).',
    },
    revokeAllForUser: {
        method: 'DELETE',
        path: '/api/users/:id/connections',
        pathParams: ConnectionIdParamsSchema,
        body: z.undefined().optional(),
        responses: { 200: UserConnectionRevokeResultSchema, ...errorResponses },
        summary: 'Revoke every user connection of a user (IT).',
    },
    revokeForUser: {
        method: 'DELETE',
        path: '/api/users/:id/connections/:connectionId',
        pathParams: UserConnectionParamsSchema,
        body: z.undefined().optional(),
        responses: { 200: UserConnectionRevokeResultSchema, ...errorResponses },
        summary: 'Revoke one user connection of a user (IT).',
    },
});
//# sourceMappingURL=user-connections.js.map